import React, { useEffect, useState } from "react";
import { YOUTUBE_SUGGESTIONS_API } from "../utils/contants";
import VideoCard, { AdVideoCard } from "./VideoCard";
import { Link } from "react-router-dom";

const SuggestionsContainer = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    getVideos();
  }, []);

  const getVideos = async () => {
    const data = await fetch(YOUTUBE_SUGGESTIONS_API);
    const json = await data.json();
    setVideos(json.items);
  };

  return (
    <div className="md:w-[30%] w-[5%] flex flex-wrap">
      {videos[0] && <AdVideoCard info={videos[0]} />}
      {videos.map((video) => (
        <Link key={video.id} to={"/watch?v=" + video.id}>
          <VideoCard info={video} />
        </Link>
      ))}
    </div>
  );
};

export default SuggestionsContainer;
